var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HotSprings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q7QTL45tcCHRFVI3Q240Ba",
    x1: 24,
    x2: 24,
    y1: 15.873,
    y2: 41.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q7QTL45tcCHRFVI3Q240Ba)",
    d: "M42,17c-1.657,0-3-1-3-1s-1.343,1-3,1s-3-1-3-1s-1.343,1-3,1s-3-1-3-1s-1.343,1-3,1s-3-1-3-1 s-1.343,1-3,1s-3-1-3-1s-1.343,1-3,1s-3-1-3-1s-1.343,1-3,1s-3-1-3-1v22c0,2.209,1.791,4,4,4h34c2.209,0,4-1.791,4-4V16 C45,16,43.657,17,42,17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M18,14c-0.553,0-1-0.447-1-1V6c0-0.553,0.447-1,1-1s1,0.447,1,1v7C19,13.553,18.553,14,18,14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M30,14c-0.553,0-1-0.447-1-1V6c0-0.553,0.447-1,1-1s1,0.447,1,1v7C31,13.553,30.553,14,30,14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M24,14c-0.553,0-1-0.447-1-1V8c0-0.553,0.447-1,1-1s1,0.447,1,1v5C25,13.553,24.553,14,24,14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M36,14c-0.553,0-1-0.447-1-1V8c0-0.553,0.447-1,1-1s1,0.447,1,1v5C37,13.553,36.553,14,36,14z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M12,14c-0.553,0-1-0.447-1-1V8c0-0.553,0.447-1,1-1s1,0.447,1,1v5C13,13.553,12.553,14,12,14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 26,
    r: 2,
    fill: "#81d4fa"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 29,
    r: 2,
    fill: "#81d4fa"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 36,
    r: 1,
    fill: "#81d4fa"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 24,
    r: 1,
    fill: "#81d4fa"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 30,
    r: 1,
    fill: "#81d4fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HotSprings);
export default __webpack_public_path__ + "static/media/icons8-hot-springs.8880922f130517929277f41650d697b8.svg";
export { ForwardRef as ReactComponent };